import React      from 'react';
import Loading    from 'pu-react/containers/Loading';
import Parameters from './Parameters';

export default () => (
  <div>
    <Loading />
    <div className="row">
      <div className="col-12">
        <Parameters />
      </div>
    </div>
  </div>
);
